import { Button, Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React from 'react';

import { messageError } from '../../../../../../Resume/utils';
import { handleExportSentOrder, tableHead } from '../constants';

import { StatusIcon } from './StatusIcon';

import { SentOrderItemProps } from '.';

export const Mobile: React.FC<SentOrderItemProps> = ({ order, onSelect }) => {
  return (
    <Shadow
      level={1}
      borderRadius={BoxRadius.sm}
      padding={Spacing['inset.xs']}
      marginBottom={Spacing['inset.xs']}
      marginTop={Spacing['inset.nano']}
      marginX={Spacing['inset.xs']}>
      <VStack space={Spacing['stack.nano']}>
        <HStack justifyContent="space-between" alignItems="center">
          <Text fontSize={Typography['fontsize.lg']} variant="semibold">
            {order?.orderHash || messageError}
          </Text>
          <HStack space={Spacing['stack.nano']}>
            <StatusIcon order={order} />
            <Pressable
              testID="order-history-button-icon"
              onPress={() => handleExportSentOrder(order)}>
              <Icon
                testId="order-history-icon"
                name="Pdf"
                size="sm"
                color={Color['brand.tertiary.principal']}
              />
            </Pressable>
          </HStack>
        </HStack>

        <HStack>
          <VStack flex={1} space={Spacing['stack.nano']}>
            <Text variant="bold">{tableHead.sentDate}</Text>
            <Text>{order.orderDateNormalized}</Text>
          </VStack>
          <VStack flex={1} space={Spacing['stack.nano']}>
            <Text variant="bold">{tableHead.customerName}</Text>
            <Text>{order.customerNormalized.customerNameNormalized}</Text>
          </VStack>
        </HStack>

        <HStack>
          <VStack flex={1} space={Spacing['stack.nano']}>
            <Text variant="bold">{tableHead.account}</Text>
            <Text>{order.accountNormalized.custodyNumberNormalized}</Text>
          </VStack>
          <VStack flex={1} space={Spacing['stack.nano']}>
            <Text variant="bold">{tableHead.product}</Text>
            <Text>{order.marketTypeNormalized}</Text>
          </VStack>
        </HStack>

        <HStack>
          <VStack flex={1} space={Spacing['stack.nano']}>
            <Text variant="bold">{tableHead.sentValue}</Text>
            <Text>{order.requestedAmountNormalized}</Text>
          </VStack>
          <Box flex={1}>
            <Button onPress={() => onSelect(order)}>DETALHES</Button>
          </Box>
        </HStack>
      </VStack>
    </Shadow>
  );
};
